import { TConfig } from '@@/auto/interfaces';
import Footer from '@@/common/components/Footer';
import Logo from '@@/common/components/Logo';

import './ErrorBoundaryView.css';

type TErrorBoundaryView = {} & Pick<
  TConfig,
  'errorPageConfig' | 'errorBoundaryConfig'
>;

function ErrorBoundaryView({
  errorPageConfig,
  errorBoundaryConfig,
}: TErrorBoundaryView) {
  const { backgroundImgSrc } = errorPageConfig;
  const { email = 'support@gettoggle.com' } = errorBoundaryConfig;
  return (
    <div className="ErrorBoundaryView">
      <main
        className="ErrorBoundaryView-bgWrapper"
        style={{
          backgroundImage: `url(${backgroundImgSrc}`,
        }}
      >
        <div className="ErrorBoundaryView-container">
          <Logo overrideClasses={{ root: 'ErrorBoundaryView-logo' }} />
          <h2 className="ErrorBoundaryView-heading">
            Oops! Something went wrong :(
          </h2>
          <p className="ErrorBoundaryView-info">
            It looks like we&apos;ve run into an error. Please try refreshing
            the page.
            <br />
            If you continue to experience issues please contact us at{' '}
            <a data-testid="errorBoundary_email" href={`mailto:${email}`}>
              {email}
            </a>
            .
            <br />
            We apologize for the inconvenience.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ErrorBoundaryView;
